const allCountries = {
      "AL": {
        "name": "Albania",
        "url": "https:\/\/savannahs.com"
      },
      "AD": {
        "name": "Andorra",
        "url": "https:\/\/savannahs.com"
      },
      "AO": {
        "name": "Angola",
        "url": "https:\/\/savannahs.com"
      },
      "AU": {
        "name": "Australia",
        "url": "https:\/\/au.savannahs.com"
      },
      "AT": {
        "name": "Austria",
        "url": "https:\/\/eu.savannahs.com"
      },
      "AZ": {
        "name": "Azerbaijan",
        "url": "https:\/\/savannahs.com"
      },
      "BH": {
        "name": "Bahrain",
        "url": "https:\/\/savannahs.com"
      },
      "BY": {
        "name": "Belarus",
        "url": "https:\/\/savannahs.com"
      },
      "BE": {
        "name": "Belgium",
        "url": "https:\/\/eu.savannahs.com"
      },
      "BM": {
        "name": "Bermuda",
        "url": "https:\/\/savannahs.com"
      },
      "BA": {
        "name": "Bosnia and Herzegovina",
        "url": "https:\/\/savannahs.com"
      },
      "BR": {
        "name": "Brazil",
        "url": "https:\/\/savannahs.com"
      },
      "BN": {
        "name": "Brunei",
        "url": "https:\/\/savannahs.com"
      },
      "BG": {
        "name": "Bulgaria",
        "url": "https:\/\/eu.savannahs.com"
      },
      "KH": {
        "name": "Cambodia",
        "url": "https:\/\/savannahs.com"
      },
      "CA": {
        "name": "Canada",
        "url": "https:\/\/savannahs.com"
      },
      "CL": {
        "name": "Chile",
        "url": "https:\/\/savannahs.com"
      },
      "CN": {
        "name": "China",
        "url": "https:\/\/savannahs.com"
      },
      "CO": {
        "name": "Colombia",
        "url": "https:\/\/savannahs.com"
      },
      "HR": {
        "name": "Croatia",
        "url": "https:\/\/eu.savannahs.com"
      },
      "CY": {
        "name": "Cyprus",
        "url": "https:\/\/eu.savannahs.com"
      },
      "CZ": {
        "name": "Czech Republic",
        "url": "https:\/\/eu.savannahs.com"
      },
      "DK": {
        "name": "Denmark",
        "url": "https:\/\/eu.savannahs.com"
      },
      "EE": {
        "name": "Estonia",
        "url": "https:\/\/eu.savannahs.com"
      },
      "FI": {
        "name": "Finland",
        "url": "https:\/\/eu.savannahs.com"
      },
      "FR": {
        "name": "France",
        "url": "https:\/\/eu.savannahs.com"
      },
      "GE": {
        "name": "Georgia",
        "url": "https:\/\/savannahs.com"
      },
      "DE": {
        "name": "Germany",
        "url": "https:\/\/eu.savannahs.com"
      },
      "GI": {
        "name": "Gibraltar",
        "url": "https:\/\/savannahs.com"
      },
      "GR": {
        "name": "Greece",
        "url": "https:\/\/eu.savannahs.com"
      },
      "HK": {
        "name": "Hong Kong",
        "url": "https:\/\/savannahs.com"
      },
      "HU": {
        "name": "Hungary",
        "url": "https:\/\/eu.savannahs.com"
      },
      "IN": {
        "name": "India",
        "url": "https:\/\/savannahs.com"
      },
      "IE": {
        "name": "Ireland",
        "url": "https:\/\/eu.savannahs.com"
      },
      "IL": {
        "name": "Israel",
        "url": "https:\/\/savannahs.com"
      },
      "IT": {
        "name": "Italy",
        "url": "https:\/\/eu.savannahs.com"
      },
      "JP": {
        "name": "Japan",
        "url": "https:\/\/savannahs.com"
      },
      "KW": {
        "name": "Kuwait",
        "url": "https:\/\/savannahs.com"
      },
      "LV": {
        "name": "Latvia",
        "url": "https:\/\/eu.savannahs.com"
      },
      "LT": {
        "name": "Lithuania",
        "url": "https:\/\/eu.savannahs.com"
      },
      "LU": {
        "name": "Luxembourg",
        "url": "https:\/\/eu.savannahs.com"
      },
      "MO": {
        "name": "Macao",
        "url": "https:\/\/savannahs.com"
      },
      "MY": {
        "name": "Malaysia",
        "url": "https:\/\/savannahs.com"
      },
      "MT": {
        "name": "Malta",
        "url": "https:\/\/eu.savannahs.com"
      },
      "MX": {
        "name": "Mexico",
        "url": "https:\/\/savannahs.com"
      },
      "MD": {
        "name": "Moldova",
        "url": "https:\/\/savannahs.com"
      },
      "MA": {
        "name": "Morocco",
        "url": "https:\/\/savannahs.com"
      },
      "NL": {
        "name": "Netherlands",
        "url": "https:\/\/eu.savannahs.com"
      },
      "NZ": {
        "name": "New Zealand",
        "url": "https:\/\/savannahs.com"
      },
      "NG": {
        "name": "Nigeria",
        "url": "https:\/\/savannahs.com"
      },
      "NO": {
        "name": "Norway",
        "url": "https:\/\/savannahs.com"
      },
      "OM": {
        "name": "Oman",
        "url": "https:\/\/savannahs.com"
      },
      "PK": {
        "name": "Pakistan",
        "url": "https:\/\/savannahs.com"
      },
      "PL": {
        "name": "Poland",
        "url": "https:\/\/eu.savannahs.com"
      },
      "PT": {
        "name": "Portugal",
        "url": "https:\/\/eu.savannahs.com"
      },
      "PR": {
        "name": "Puerto Rico",
        "url": "https:\/\/savannahs.com"
      },
      "QA": {
        "name": "Qatar",
        "url": "https:\/\/savannahs.com"
      },
      "RO": {
        "name": "Romania",
        "url": "https:\/\/eu.savannahs.com"
      },
      "SA": {
        "name": "Saudi Arabia",
        "url": "https:\/\/savannahs.com"
      },
      "SG": {
        "name": "Singapore",
        "url": "https:\/\/savannahs.com"
      },
      "SK": {
        "name": "Slovakia",
        "url": "https:\/\/eu.savannahs.com"
      },
      "SI": {
        "name": "Slovenia",
        "url": "https:\/\/eu.savannahs.com"
      },
      "KR": {
        "name": "South Korea",
        "url": "https:\/\/savannahs.com"
      },
      "ES": {
        "name": "Spain",
        "url": "https:\/\/eu.savannahs.com"
      },
      "SE": {
        "name": "Sweden",
        "url": "https:\/\/se.savannahs.com"
      },
      "CH": {
        "name": "Switzerland",
        "url": "https:\/\/savannahs.com"
      },
      "TW": {
        "name": "Taiwan",
        "url": "https:\/\/savannahs.com"
      },
      "TH": {
        "name": "Thailand",
        "url": "https:\/\/savannahs.com"
      },
      "TR": {
        "name": "Turkey",
        "url": "https:\/\/savannahs.com"
      },
      "UA": {
        "name": "Ukraine",
        "url": "https:\/\/savannahs.com"
      },
      "AE": {
        "name": "United Arab Emirates",
        "url": "https:\/\/savannahs.com"
      },
      "GB": {
        "name": "United Kingdom",
        "url": "https:\/\/uk.savannahs.com"
      },
      "US": {
        "name": "United States",
        "url": "https:\/\/savannahs.com"
      },
      "VN": {
        "name": "Vietnam",
        "url": "https:\/\/savannahs.com"
      },
      "WO": {
        "name": "Other Countries",
        "url": "https:\/\/savannahs.com"
      }
    };

const redirectCountries = [
      "AT",
      "BE",
      "BG",
      "CY",
      "CZ",
      "DK",
      "EE",
      "FI",
      "FR",
      "DE",
      "GR",
      "HU",
      "HR",
      "IE",
      "IT",
      "LV",
      "LT",
      "LU",
      "MT",
      "NL",
      "PL",
      "PT",
      "RO",
      "SK",
      "SI",
      "ES",
      "GB",
      "AU",
  	  "SE"
    ];